import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import ModifierSetAccordion from './ModifierSetAccordion';
import Accordion from '../../../foundation/components/Accordion';
import { getModifierSetModifiers } from '../../services/catalog';
import { MenuCatalogModifierSetPropType, MenuCatalogModifierPropType } from '../../types/menu-catalog';
import './ModifierSetsAccordions.css';
var defaultProps = {
  modifierSets: [],
  modifiers: [],
  displayDescription: false,
  displayMinMaxAllowed: false,
  defaultOpenIndices: [0]
};
export default function ModifierSetsAccordions(_ref) {
  var modifierSets = _ref.modifierSets,
    modifiers = _ref.modifiers,
    displayDescription = _ref.displayDescription,
    displayMinMaxAllowed = _ref.displayMinMaxAllowed,
    defaultOpenIndices = _ref.defaultOpenIndices;
  if (_isEmpty(modifierSets) || _isEmpty(modifiers)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Accordion, {
    className: "modifier-sets-accordions"
  }, modifierSets.map(function (modifierSet, index) {
    var _id = modifierSet._id,
      name = modifierSet.name;
    var modifiersInSet = getModifierSetModifiers(modifierSet, modifiers);
    if (_isEmpty(modifiersInSet)) {
      return null;
    }
    return /*#__PURE__*/React.createElement(ModifierSetAccordion, {
      key: "".concat(_id, "_").concat(name),
      modifierSet: modifierSet,
      modifiers: modifiersInSet,
      defaultOpen: defaultOpenIndices.includes(index),
      displayDescription: displayDescription,
      displayMinMaxAllowed: displayMinMaxAllowed
    });
  }));
}
ModifierSetsAccordions.defaultProps = defaultProps;